import { Link } from "react-router-dom";

import DefRoutes from "../../routes/routes.json";
import t from "../../i18n/i18n";
import initPage from "../../utils/initPage";

import Template from "../../template/template";
import UserBox from "./userBox/userBox";

function RechargeCenter() {
  initPage({
    title: t("RechargeCenter.Title"),
  });

  return (
    <Template>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="chargin-warp-main">
              <div className="chargin-col-left">
                <UserBox />
                <div className="chargin-box-panel">
                  <div className="top-up-option">
                    <h3>{t("RechargeCenter.ClickOptions")}</h3>
                    <ul className="option-list">
                      <li>
                        <Link to={DefRoutes.RechargeCupons}>
                          <img src={t("Images.A018")} alt="" />
                        </Link>
                      </li>
                      <li>
                        <Link to={DefRoutes.RechargeCredit}>
                          <img src={t("Images.A019")} alt="" />
                        </Link>
                      </li>
                      <li>
                        <Link to={DefRoutes.RechargeLoyalMember}>
                          <img src={t("Images.A020")} alt="" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="chargin-col-right">
                <div className="chargin-banner-box">
                  <a href="#">
                    <img src={t("Images.A001")} className="view-large" />
                    <img src={t("Images.A002")} className="view-small" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Template>
  );
}

export default RechargeCenter;
